import axios from 'axios';

import request from '@/api/axiosFun'
export const getcode = () => { 
    
        return request({
            url: 'login/get_code',
            headers:{
            //   'Accept': 'image/*',
            },
         //   responseType: "arraybuffer",
            method: 'post',       
        })
};


export  const login=(info)=>{
    console.log(info);
    return request({
            url:"login/submit",
            method:"post",
            data:info
        })
    }

export const loginout = () => { return axios({
    url: 'login/get_code',

    headers:{
     //   'Accept': 'image/*',
    },
    responseType: "arraybuffer",
    method: 'post',       
 }).then(res=>{
     //   console.log(res);
   
    return res.data;
 }) 
};


export const addAdmin=(info)=>{
    return request({
        url:"system/creatAdmin",
        method:"post",
        data:info
    })

}


export const editAdmin=(info)=>{
    return request({
        url:"system/editAdmin",
        method:"post",
        data:info
    })

}

export const changeAdminStatus=(info)=>{
    return request({
        url:"system/changeAdminStatus",
        method:"post",
        data:info
    })

}


export const adminDelete=(info)=>{
    return request({
        url:"system/deleteAdmin",
        method:"post",
        data:info
    })

}
export const getAdminById=(info)=>{
    return request({
        url:"system/getAdminById",
        method:"post",
        data:info
    })

}

export const get_admin_list=(info)=>{
    return request({
        url:"system/adminList",
        method:"post",
        data:info
    })

}
    
export const roleList=()=>{
    return request({
        url:"system/role_list",
        method:"post",
       // data:info
    })

}

    export const ModuleList=()=>{
        return request({
            url:"system/menu",
            method:"post",
            // data:info
        })

    }
    export const create_role=(data)=>{
        return request({
            url:"system/creatRole",
            method:"post",
            data
        })

    }

    export const role_list=(data)=>{
        return request({
            url:"system/role_list",
            method:"post",
            data
        })

    }

    export const editRole=(data)=>{
        return request({
            url:"system/getroleById",
            method:"post",
            data
        })

    }


    export const deleteRole=(data)=>{
        return request({
            url:"system/deleteRole",
            method:"post",
            data
        })

    }

    export const parent_menu=()=>{
        return request({
            url:"system/getParent",
            method:"post",
          
        })

    }
    export const menu_list=()=>{
        return request({
            url:"system/menuList",
            method:"post",
          
        })

    }
    //删除菜单
    export const menu_del=(id)=>{
        return request({
            url:"system/menu_del",
            method:"post",
            data:{
                id
            }
          
        })

    }

    export const menu_edit=(data)=>{
        return request({
            url:"system/menu_edit",
            method:"post",
            data
          
        })

    }

    

    export const menuById=(id)=>{
        return request({
            url:"system/getmenuById",
            method:"post",
            data:{
                id
            }
          
        })

    }

    export const changePass=(data)=>{
        return request({
            url:"system/changePass",
            method:"post",
            data
          
        })

    }

    export const expireTime=()=>{
        return request({
            url:"system/expireTime",
            method:"post",
        })

    }
    export const  UnlockUser=(data)=>{
        return request({
            url:"system/UnlockUser",
            method:"post",
            data
        })

    }
   
    export const  addproduct=(data)=>{
        return request({
            url:"system/addproduct",
            method:"post",
            data
        })

    }
    export const  ProductList=()=>{
        return request({
            url:"system/ProductList",
            method:"post",
           
        })

    }
    
    export const  ProductById=(data)=>{
        return request({
            url:"system/ProductById",
            method:"post",
            data
           
        })

    }

        
    export const  meal_list=(data)=>{
        return request({
            url:"system/meal_list",
            method:"post",
            data
           
        })

    }

    export const  addMeal=(data)=>{
        return request({
            url:"system/addMeal",
            method:"post",
            data
           
        })

    }
    export const  saveMeal=(data)=>{
        return request({
            url:"system/saveMeal",
            method:"post",
            data
           
        })

    }
    
     
    export const  editMeal=(id)=>{
        return request({
            url:"system/editMeal",
            method:"post",
            data:{
                id
            }
           
        })

    }
    
    export const  saveBelong=(data)=>{
        return request({
            url:"system/saveBelong",
            method:"post",
            data
           
        })

    }

    export const  ListBelong=()=>{
        return request({
            url:"system/ListBelong",
            method:"post",
           
           
        })

    }
    export const  editBelong=(id)=>{
        return request({
            url:"system/editBelong",
            method:"post",
            data:{
                id
            }
           
           
        })

    }


    export const  saveProvide=(data)=>{
        return request({
            url:"system/saveProvide",
            method:"post",
            data
           
        })

    }

    export const  ListProvide=()=>{
        return request({
            url:"system/ListProvide",
            method:"post",

        })
    }
    export const  editProvide=(id)=>{
        return request({
            url:"system/ProvidetById",
            method:"post",
            data:{
                id
            }
        })

    }
    export const  editStatus=(id)=>{
        return request({
            url:"system/editStatus",
            method:"post",
            data:{
                id
            }
        })

    }
    export const  ListStatus=()=>{
        return request({
            url:"system/StatusList",
            method:"post",

        })
    }
    
    export const  saveStatus=(data)=>{
        return request({
            url:"system/addStatus",
            method:"post",
            data
           
        })

    }
    export const  delMeal=(data)=>{ //删除套餐
        return request({
            url:"system/delMeal",
            method:"post",
            data
           
        })
    }
    export const  deleteBelong=(data)=>{ //删除套餐
        return request({
            url:"system/deleteBelong",
            method:"post",
            data
           
        })
    }
    export const  deleteProvide=(data)=>{ //删除供应商
        return request({
            url:"system/deleteProvide",
            method:"post",
            data
           
        })
    }
    
    export const  ChangeStatus=(data)=>{ //修改状态是否可以选择
        return request({
            url:"system/ChangeStatus",
            method:"post",
            data
           
        })
    }


    export const  updateMeal=(data)=>{ //修改套餐ID
        return request({
            url:"system/updateMeal",
            method:"post",
            data
           
        })
    }

   

    


// WEBPACK FOOTER //
// ./src/api/userFun.js